const CubeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="81"
    height="94"
    viewBox="0 0 81 94"
    fill="none"
    {...props}
  >
    <path
      d="M0.627686 24L40.8087 48.0756V93.924L0.627686 69.8484V24Z"
      fill="#DDB96E"
    />
    <path
      d="M0.622559 24.0023L40.8085 48.0744L80.6089 24.19L40.4092 0.117838L0.622559 24.0023Z"
      fill="#F9E4B9"
    />
    <path
      d="M40.8086 48.0758L80.6225 24.1768V70.0252L40.8086 93.9242V48.0758Z"
      fill="#7C612E"
    />
  </svg>
);

export default CubeIcon;
